import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("plw_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getToken = () => localStorage.getItem("plw_token") || "";

export const imageUrl = (path) => {
  if (!path) return null;
  const token = getToken();
  return `${API}/files/${path}?auth=${encodeURIComponent(token)}`;
};
